var render, staticRenderFns
import script from "./Stays.vue?vue&type=script&lang=ts&"
export * from "./Stays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7219ad')) {
      api.createRecord('2d7219ad', component.options)
    } else {
      api.reload('2d7219ad', component.options)
    }
    
  }
}
component.options.__file = "src/components/home/mixins/Stays.vue"
export default component.exports